import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { universalStyles, white } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  heading: {
    marginTop: 24,
  },
  text: {
    color: white,
  },
}));

const InterpretationPage08 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6" className={classes.heading}>
        Purpose
      </Typography>
      <ul className={classNames(classes.list, classes.text)}>
        <li>
          To effectively identify and localize recurrent prostate cancer on PET/CT or PET/MRI images acquired with
          Axumin, we recommend following a particular set of steps
        </li>
        <li>
          In this training, you will first explore the methodology for interpreting images, and then be given the
          opportunity to practice
        </li>
      </ul>
      <Typography variant="h6" className={classes.heading}>
        Objectives of this section include:
      </Typography>
      <ul className={classNames(classes.list, classes.text)}>
        <li>Identify the steps needed for better identification and interpretation of prostate cancer lesions</li>
        <li>
          Identify the expected physiologic uptake mechanism, incidental findings, and normal variants with Axumin
        </li>
      </ul>
      <Typography variant="h6" className={classes.heading}>
        Note that the following resources are available in the Downloadable Resources section:
      </Typography>
      <ol className={classNames(classes.list, classes.orderedList, classes.text)}>
        <li>Axumin Injection Interpretation Criteria Card</li>
        <li>Axumin Interpretation Report Example</li>
      </ol>
      <Typography variant="h6" className={classes.heading}>
        Important considerations before beginning:
      </Typography>
      <ul className={classNames(classes.list, classes.text)}>
        <li>Image quality can be improved during image acquisition and image reconstruction</li>
        <li>
          Imaging interpretation is predominantly qualitative, based on typical sites of recurrent prostate cancer
        </li>
        <ul className={classNames(classes.list, classes.nestedList, classes.text)}>
          <li>
            As with any imaging, full correlation with all available information (eg, medical history, laboratory
            results, bone scans, CT and MRI scans) should occur and may improve the confidence level of interpretation
            of the PET scan
          </li>
        </ul>
      </ul>
      <Typography variant="h6" className={classes.heading}>
        Explore each step to learn more about image interpretation:
      </Typography>
      <ul className={classNames(classes.list, classes.text)}>
        <li>Proceed to the next page to view the 5 steps</li>
      </ul>
    </>
  );
};

export default InterpretationPage08;
